import moment from "moment"

const defaultFields = () => ({
	invoice_id: {label: "", id: 0},
	amount: 0,
	description: "",
	date: moment().format("YYYY-MM-DD"),
})

const defaultErrors = () => ({
	invoice_id: "",
	amount: "",
	date: "",
	description: ""
})

export {
	defaultFields, defaultErrors
}
